module.exports = __webpack_public_path__ + "img/logo.19b09581.png";